import { createRouter, createWebHashHistory } from 'vue-router';
import { authToken } from '@/constants';
import { setTitle, storage } from '@/utils';
import i18n from '@/i18n';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home'),
    meta: {
      titleKey: 'Home',
      tabShow: true,
    },
  },
  {
    path: '/query',
    name: 'Query',
    component: () => import('@/views/Query'),
    meta: {
      titleKey: 'Query',
      tabShow: true,
    },
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/views/Order'),
    meta: {
      titleKey: 'Order',
      tabShow: true,
    },
  },
  {
    path: '/orderDetail/:id',
    name: 'OrderDetail',
    component: () => import('@/views/Order/components/OrderDetail'),
    meta: {
      titleKey: 'OrderDetail',
      tabShow: true,
    },
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/My'),
    meta: {
      titleKey: 'My',
      tabShow: true,
    },
  },
  {
    path: '/setting',
    name: 'Setting',
    component: () => import('@/views/Setting'),
    meta: {
      titleKey: 'Setting',
      tabShow: false,
    },
  },
  {
    path: '/avatar',
    name: 'Avatar',
    component: () => import('@/views/Setting/components/Avatar.vue'),
    meta: {
      titleKey: 'Avatar',
      tabShow: false,
    },
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: () => import('@/views/My/components/ChangePassword.vue'),
    meta: {
      titleKey: 'ChangePassword',
      tabShow: false,
    },
  },
  {
    path: '/printTemplate',
    name: 'PrintTemplate',
    component: () => import('@/views/Setting/components/PrintTemplate.vue'),
    meta: {
      titleKey: 'PrintTemplate',
      tabShow: false,
    },
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('@/views/My/components/Recharge'),
    meta: {
      titleKey: 'Recharge',
      tabShow: false,
    },
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import('@/views/My/components/Message'),
    meta: {
      titleKey: 'Message',
      tabShow: false,
    },
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/views/My/components/Withdraw'),
    meta: {
      titleKey: 'Withdraw',
      tabShow: false,
    },
  },
  {
    path: '/successOrder',
    name: 'SuccessOrder',
    component: () => import('@/views/Home/components/SuccessOrder'),
    meta: {
      titleKey: 'SuccessOrder',
      tabShow: false,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register/index.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

// 路由白名单(不需要token的)
const whiteList = ['/login', '/register'];
// 路由前置守卫
router.beforeEach(async (to, from, next) => {
  console.log('路由进来了', storage.getItem(authToken));
  // 存在token, 进入主页,不存在就到登录页面
  if (storage.getItem(authToken)) {
    if (to.path === '/login') {
      next('/');
    } else {
      next();
    }
  } else {
    // 没有token的情况下, 可以进入白名单
    if (whiteList.indexOf(to.path) > -1) {
      next();
    } else {
      next('/login');
    }
  }
  // 设置标题(根据当前语言翻译)
  const titleKey = to.meta.titleKey;
  const title = titleKey ? i18n.global.t(`routeTitle.${titleKey}`) : '';
  setTitle(title);
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});
export default router;
